module.exports = __webpack_public_path__ + "static/media/zarty.1fea60d8.png";